import { render } from "./UserAvatar.vue?vue&type=template&id=1d30b34c&scoped=true&ts=true"
import script from "./UserAvatar.vue?vue&type=script&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&lang=ts"

import "./UserAvatar.vue?vue&type=style&index=0&id=1d30b34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d30b34c"],['__file',"src/components/profile/UserAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d30b34c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d30b34c', __exports__)) {
    api.reload('1d30b34c', __exports__)
  }
  
  module.hot.accept("./UserAvatar.vue?vue&type=template&id=1d30b34c&scoped=true&ts=true", () => {
    api.rerender('1d30b34c', render)
  })

}


export default __exports__